import $ from "jquery";

$("#secondary-menu-toggler").click(function () {
	$(this).attr("aria-expanded","true");
	$("#secondary-menu-nav").addClass("menu--opened");
});

$("#secondary-menu-close").click(function () {
	$("#secondary-menu-toggler").attr("aria-expanded","false");
	$("#secondary-menu-nav").removeClass("menu--opened");
});


